import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from '@react-pdf/renderer'

import colors from '@settings/styleSettings'
import Text from './Text'
import Block from './icons/Block'

const styles = StyleSheet.create({
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 4,
    width: '100%',
    height: 35,
    borderRadius: 5,
    backgroundColor: colors.grayBackground,
    border: `1px solid ${colors.softGray}`,
  },
  text: {
    fontSize: 12,
    color: colors.strongGray,
    marginLeft: 8,
  },
  title: {
    fontSize: 12,
    color: colors.strongGray,
  },
  required: {
    color: colors.strongRed,
    fontSize: 12,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 0,
    marginTop: 20,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    gap: 8
  },

})

const TextWithCard = ({
  text, title
}) => (
  <View style={styles.container}>
    <View style={styles.labelContainer}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.required}>*</Text>
    </View>
    <View style={styles.inputContainer}>
      <Text style={styles.text}>
        {text}
      </Text>
      <Block color={colors.strongGray} />
    </View>
  </View>
)

TextWithCard.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default TextWithCard
